import React, { useState } from 'react';
import { Card, CardContent, Typography, Button, TextField, Box, Container,CircularProgress } from '@mui/material';
import Logo from "../../assets/Logo.svg";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ShareIcon from '@mui/icons-material/Share';
import axios from 'axios';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import background from "../../assets/background.jpg";
import Alert from '@mui/material/Alert';
import PL from '../../assets/pl.png'
import { useNavigate } from 'react-router-dom';

const UserProfileCard = () => {
  const [active, setActive] = useState(false);
  const [buttonText, setButtonText] = useState('share your info');
  const [photoPosition, setPhotoPosition] = useState({ x: '50%', y: '50%' });
  const [open, setOpen] = useState(false);
  const [toast,setToastMessage] = useState('');
  const [show,setShow] = useState(false);
  const [toastSuccess,setToastSuccess] = useState(false);
  const navigate = useNavigate();
  

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );


  // State to hold form data
    const [formData, setFormData] = useState({
        name: '',
        business_name: '',
        email: '',
        phone_number: '',
    });

     // State for error messages
    const [errors, setErrors] = useState({
        name: '',
        email: '',
        phone: '',
    });

     // Handle input change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
        ...formData,
        [name]: value,
        });
    };

    

  const handleToggle = () => {
    setActive(!active);
    setButtonText(buttonText === 'share your info' ? 'back' : 'share your info');
  };
// image move on mouse
  const handleMouseMove = (event) => {
    const docWidth = window.innerWidth;
    const docHeight = window.innerHeight;
    const xValue = (event.clientX / docWidth) * 100 + '%';
    const yValue = (event.clientY / docHeight) * 100 + '%';
    setPhotoPosition({ x: xValue, y: yValue });
  };

  // Validation logic
  const validateForm = () => {
    let valid = true;
    let newErrors = { name: '',email: ''};

    if (formData.name == '') {
      newErrors.name = 'Name is required';
      valid = false;      
    }

    if (formData.email == '') {
      newErrors.email = 'Email is required';
      valid = false;
    } 

    setErrors(newErrors);
    return valid;
  };

// savedata axios api call
const saveData = (e) => {
  e.preventDefault();
  
  if (!validateForm()) {
    return; // Stop the submission if validation fails
  }

  axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
  axios.defaults.xsrfCookieName = "csrftoken";
  setShow(true);

  axios.post('http://aibooth.purelogics.net/api/person/create_person/' ,formData)
    .then(function (response) {
      setToastSuccess(true); // Set to true for success
      setToastMessage('Your contact information was sent successfully.');
      handleClick();
      setFormData({
        name:'',
        email:'',
      });
      setShow(false);
      setErrors({ name: '', email: '', }); // Reset errors on success
      navigate('/thank-you');
    })
    .catch(function (error) {
      console.log(error,"error");
      setToastSuccess(false); // Set to false for error
      setToastMessage('There is something wrong!');
      handleClick();
    });
};

// generating vcf contact card
  const handleSaveContact = () => {
    // Define vCard content (v3.0)
    const vCardData = `
BEGIN:VCARD
VERSION:3.0
FN:Muhammad Atif
N:Atif;Muhammad;;;
ORG:Purelogics
TEL;TYPE=WORK,VOICE:+12017369684
EMAIL:muhammad.atif@purelogics.net
END:VCARD
`.trim(); // Remove any unnecessary whitespace

    // Create a blob with the vCard data and set its type to text/vcard
    const blob = new Blob([vCardData], { type: 'text/vcard;charset=utf-8' });

    // Create a link element and trigger the download
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'Muhammad Atif.vcf'; // Name of the file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up
};



  return (
    <Container 
    maxWidth="2xl"
    sx={{
        height: '100vh', // Ensures full viewport height
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start', // Align items to the top
        paddingTop: '100px',
        paddingBottom: '100px',
        background: `url('${background}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center', // Center the background image
        overflow: 'auto', // Allow overflow for scrolling
    }}>
        <Card
        onMouseMove={handleMouseMove}
        sx={{
            position: 'relative',
            maxWidth: '500px',
            width:'97%',
            height: active ? show ? '600px' : 'fit-content' : '500px',
            paddingBottom: active ? '30px' : '',
            margin: 0,
            backgroundColor: 'aliceblue',
            boxShadow: '0 0 15px rgba(0, 0, 0, 0.2)',
            transition: 'all 0.7s ease-in-out',
            overflow: active  ? 'hidden' :'auto',
            zIndex: 1,
        }}
        >
        {/* Photo Section */}
        { active ? <Box
              sx={{
                width: '100%',
                height: '150px',
                // background: `url('${background}')`,
                background: '#01081D',
                backgroundSize: 'cover',
                borderBottom: '1px solid lightgrey',
                transition: 'all 0.7s ease-in-out',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <img src={Logo} alt="stat-icon" width={240} />
            </Box>
           : (
            <Box
              sx={{
                width: '100%',
                height: '150px',
                background: '#01081D',
                // background: `url('${background}')`,
                backgroundSize: 'cover',
                borderBottom: '1px solid lightgrey',
                transition: 'all 0.7s ease-in-out',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <img src={Logo} alt="stat-icon" width={240} />
            </Box>
          )
        
        }
        
        <Box
            sx={{
            zIndex: 3,
            position: 'absolute',
            borderRadius: '50%',
            height: active ? '0' : '100px',
            width: active ? '0' : '100px',
            opacity: active ? '0' : '1',
            backgroundColor: 'white',
            margin: '0 auto',
            background: `url("${PL}") ,#fff`,
            backgroundSize: '90%',
            backgroundPosition: `${photoPosition.x} ${photoPosition.y}`,
            top: active ? '-180px' : '100px',
            left: '50%',
            transform: 'translate(-50%,0)',
            boxShadow: 'inset 0 0 5px 1px rgba(0,0,0,0.3)',
            opacity: active ? '0' : '1',
            transition: 'all 1s ease-in-out',
            }}
        />


        <CardContent>
            <Typography variant="h5" component="div" sx={{ textAlign: 'center', marginTop: active ? '20px' : '80px',color: active ? '#01081D' : 'black',transition: 'all 0.7s ease-in-out', }}>
            <b>Muhammad Atif</b>
            </Typography>
            <Typography variant="subtitle2" sx={{ textAlign: 'center',color: active ? '#01081D' : 'black' }}>
                <span>muhammad.atif@purelogics.net</span>
            </Typography>
            <Typography variant="subtitle2" sx={{ textAlign: 'center',color: active ? '#01081D' : 'black' }}>
                <span>+12017369684</span>
            </Typography>
        </CardContent>

        <Box textAlign="center" mt={2} px={2}>
            <Button
            
            variant="contained"
            color="primary"
            onClick={handleSaveContact}
            id="saveButton"
            sx={{
                width: '100%',
                // height: '35px',
                padding:'12px 0',
                backgroundColor: '#4DC369',
                textTransform: 'uppercase',
                marginBottom:'10px',
                fontSize: '14px',
                '&:hover': {
                backgroundColor: '#979da8',
                },
            }}
            startIcon={<PersonAddIcon />}
            >
            Save To Contact
            </Button>
            <Button
            variant="contained"
            color="secondary"
            onClick={handleToggle}
            id="main-button"
            sx={{
                width: '100%',
                // height: '35px',
                padding:'12px 0',
                backgroundColor: '#C7D0E1',
                textTransform: 'uppercase',
                fontSize: '12px',
                '&:hover': {
                backgroundColor: '#979da8',
                },
            }}
            startIcon={active ? '' : <ShareIcon />}
            >
            {buttonText}
            </Button>
        </Box>

        {/* {active && (
            <Box
            display="flex"
            justifyContent="center"
            mt={2}
            className="social-media-banner"
            sx={{
                opacity: active ? 1 : 0,
                visibility: active ? 'visible' : 'hidden',
                transition: 'all 1.5s ease-in-out',
            }}
            >
            <IconButton color="primary" href="#">
                <TwitterIcon />
            </IconButton>
            <IconButton color="primary" href="#">
                <FacebookIcon />
            </IconButton>
            <IconButton color="primary" href="#">
                <InstagramIcon />
            </IconButton>
            <IconButton color="primary" href="#">
                <LinkedInIcon />
            </IconButton>
            </Box>
        )} */}

            {active && (
              <Box>
                 {show ? <CircularProgress show={show} sx={{margin:"0 auto",display:'flex',marginTop: '50px',}} /> :
                <Box
                component="form"
                mt={3}
                px={2}
                display="flex"
                flexDirection="column"
                onSubmit={saveData}
                sx={{
                    width:'100%',
                    // height: active ? 'fit-content' : '0',
                    transition: 'all 1s ease-in-out',
                    overflow: 'hidden',
                    zIndex: 3,
                }}
                >
                <TextField
                    id="name"
                    label="Name"
                    variant="outlined"
                    name='name'
                    value={formData.name}
                    onChange={handleChange}
                    error={!!errors.name}
                    helperText={errors.name}
                    sx={{ mb: 2, margin: '0 auto', width:'100%', marginTop:'10px', textTransform: 'capitalize' }}
                />
                <TextField
                    id="email"
                    type="email"
                    label="Email"
                    variant="outlined"
                    name='email'
                    value={formData.email}
                    onChange={handleChange}
                    error={!!errors.email}
                    helperText={errors.email}
                    sx={{ mb: 2, margin: '0 auto', width:'100%', marginTop:'10px', textTransform: 'capitalize' }}
                />
                {/* <TextField
                    id="phone"
                    label="Phone"
                    variant="outlined"
                    name='phone_number'
                    value={formData.phone_number}
                    onChange={handleChange}
                    error={!!errors.phone_number}
                helperText={errors.phone_number}
                    sx={{ mb: 2, margin: '0 auto', width:'100%', marginTop:'10px', textTransform: 'capitalize' }}
                /> */}
            
                <Button
                    type='submit'
                    variant="contained"
                    color="secondary"
                    sx={{ mt: 2, width: '100%', margintTop: '30px', background:'#4DC369', padding:'12px 0' }}
                >
                    Send
                </Button>
                </Box>}
              </Box>
            )}

        </Card>

        <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal : 'right'}}
        open={open}
        onClose={handleClose}
        autoHideDuration={3000}
        action={action}
      >
        {toastSuccess === true ?  <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: '100%',color:'#fff' }}
        >
          {toast}
        </Alert> :<Alert
          onClose={handleClose}
          severity="error"
          variant="filled"
          sx={{ width: '100%',color:'#fff' }}
        >
          {toast}
        </Alert>   }
        
        </Snackbar>

    </Container>
  );
};

export default UserProfileCard;
